import { useEffect, useRef, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import useResumePropertiesHandlers from "../../../context/resume/hooks/resume-properties-handlers";
import useResumeProperties from "../../../hooks/useResumeProperties";

const logoOptions = [
    {
        logoLabel: "Alcyone",
        logoSrc: "/logo-cv.png",
        isAlcyone: true,
        isLusis: false,
        isEuropass: false,
        isCssf: false
    },
    {
        logoLabel: "Lusis",
        logoSrc: "/Lusis-ACO.png",
        isAlcyone: false,
        isLusis: true,
        isEuropass: false,
        isCssf: false
    },
    {
        logoLabel: "Europass - Alcyone",
        logoSrc: "/europass-logo.jpg",
        isAlcyone: true,
        isLusis: false,
        isEuropass: true,
        isCssf: false
    },
    {
        logoLabel: "Europass - Lusis",
        logoSrc: "/europass-logo.jpg",
        isAlcyone: false,
        isLusis: true,
        isEuropass: true,
        isCssf: false
    },
    {
        logoLabel: "CSSF",
        logoSrc: "/cssf-logo.png",
        isAlcyone: false,
        isLusis: false,
        isEuropass: false,
        isCssf: true
    },
];

export default function LogoSelection() {
    const [ isOpen, setOpen ] = useState( false );
    const { logoLabel } = useResumeProperties();
    const { handleChangeMultiple } = useResumePropertiesHandlers();

    const logo = logoOptions.find( logoOption => logoOption.logoLabel === logoLabel ) || logoOptions[ 0 ];

    const [ currentSelection, setCurrentSelection ] = useState( logo );

    const handleSelect = ( logoOption ) => {
        handleChangeMultiple( [
            {
                name: 'logoLabel',
                value: logoOption.logoLabel
            },
            {
                name: 'logoSrc',
                value: logoOption.logoSrc
            },
            {
                name: 'isAlcyone',
                value: logoOption.isAlcyone
            },
            {
                name: 'isLusis',
                value: logoOption.isLusis
            },
            {
                name: 'isEuropass',
                value: logoOption.isEuropass
            },
            {
                name: 'isCssf',
                value: logoOption.isCssf
            },
        ] );
        setCurrentSelection( logoOption );
        setOpen( false );
    };

    const dropdownRef = useRef( null );
    useEffect( () => {
        const handleClickOutside = ( event ) => {
            if ( dropdownRef.current && !dropdownRef.current.contains( event.target ) ) {
                setOpen( false );
            }
        };

        document.addEventListener( "mousedown", handleClickOutside );
        return () => {
            document.removeEventListener( "mousedown", handleClickOutside );
        };
    }, [] );

    return (
        <div className="d-flex flex-column gap-3 p-2 align-items-end w-100">
            <div className="position-relative w-50" ref={ dropdownRef }>
                <div
                    className="d-flex align-items-center p-2 bg-white w-100"
                    style={ {
                        cursor: "pointer",
                        borderRadius: "10px",
                        border: "2px solid #09B4BF",
                        width: "200px",
                        justifyContent: "space-between",
                    } }
                    onClick={ () => setOpen( !isOpen ) }
                >
                    <div className="d-flex align-items-center">
                        <img
                            src={ currentSelection.logoSrc }
                            alt={ currentSelection.logoLabel }
                            style={ {
                                height: "40px",
                                width: "35px",
                                borderRadius: "8px",
                                marginRight: "10px",
                                objectFit: "contain",
                            } }
                        />
                        <span style={ {
                            fontSize: "16px",
                            fontWeight: "500"
                        } }>
                            { currentSelection.logoLabel }
                        </span>
                    </div>
                    <FaChevronDown/>
                </div>
                { isOpen && (
                    <div
                        className="position-absolute mt-2 bg-white shadow w-100"
                        style={ {
                            borderRadius: "10px",
                            border: "1px solid #ccc",
                            width: "200px",
                            zIndex: "10",
                        } }
                    >
                        { logoOptions.map( ( logoOption, index ) => (
                            <div
                                key={ index }
                                className="d-flex align-items-center p-2"
                                style={ {
                                    cursor: "pointer",
                                    borderRadius: "8px",
                                    background:
                                        currentSelection.logoLabel === logoOption.logoLabel ? "#f0f9fa" : "white",
                                } }
                                onClick={ () => handleSelect( logoOption ) }
                            >
                                <img
                                    src={ logoOption.logoSrc }
                                    alt={ logoOption.logoLabel }
                                    style={ {
                                        height: "40px",
                                        width: "35px",
                                        borderRadius: "8px",
                                        marginRight: "10px",
                                        objectFit: "contain",
                                    } }
                                />
                                <span style={ { fontSize: "16px", fontWeight: "500" } }>{ logoOption.logoLabel }</span>
                            </div>
                        ) ) }
                    </div>
                ) }
            </div>
        </div>
    );
}
